import { render, staticRenderFns } from "./ticket_related_types.vue?vue&type=template&id=2db9ce2c&scoped=true&"
import script from "./ticket_related_types.vue?vue&type=script&lang=js&"
export * from "./ticket_related_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db9ce2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2db9ce2c')) {
      api.createRecord('2db9ce2c', component.options)
    } else {
      api.reload('2db9ce2c', component.options)
    }
    module.hot.accept("./ticket_related_types.vue?vue&type=template&id=2db9ce2c&scoped=true&", function () {
      api.rerender('2db9ce2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/ticket_related_types.vue"
export default component.exports